// extracted by mini-css-extract-plugin
export default {"container":"SeriesBanner_container__4Pauk","content":"SeriesBanner_content__cJhxs","seriesName":"SeriesBanner_seriesName__zS4eg","workContainer":"SeriesBanner_workContainer__Dlvfg"};